<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="tableData" border default-expand-all stripe :header-cell-style="{'text-align':'center'}" style="width: 100%;margin-bottom: 20px;">
        <el-table-column prop="ID" label="序号" />
        <el-table-column prop="createTime" label="日期" />
        <el-table-column prop="moneyTotail" label="商家" />
        <el-table-column prop="moneyTotail" label="次数" />
        <el-table-column prop="remarks" label="物流" />
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "ExpressSingleNumChart",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
